import React, {useCallback, useContext} from "react";
import useTranslate from "../../../../modules/local/useTranslate";
import {FollowButton, JoinButton} from "../../custom/ToggleActionButton";
import OrganizationContainerContext from "../OrganizationContainerContext";
import classNames from "classnames";
import {BsPersonFill} from "react-icons/bs";
import {Avatar, Modal} from "antd";
import {IoExitOutline} from "react-icons/io5";
import {useJoin} from "../../../Server/ServerContainer";
import _ from "lodash";
import {getId, getType} from "../../../../apis/model/base";
import {OrganizationShareWidget} from "../../factory/createShareWidget";
import {LoginContext} from "../../../../components/LoginContext";
import TooltipApp from "../../../../components/TooltipApp";
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";

const UseJoinAction = ({id, type, children, join_status}) => {
    const handleJoin = useJoin({
        id,
        type,
        status: join_status,
    })

    return _.isFunction(children)
        ? children(handleJoin, {id, type})
        : children || null
}

const ActionMemberLeave = (props) => {
    const t = useTranslate()
    const showConfirmDialog = useCallback(
        (onOk) =>
            Modal.confirm({
                title: t('do you want to leave'),
                content: (
                    <span className="text-sm text-color-400 italic">
                        {t('you will no longer be a member of this community')}
                    </span>
                ),
                className: 'custom-modal',
                okText: t('sure'),
                cancelText: t('ignore'),
                okButtonProps: {
                    type: 'primary',
                    danger: true,
                    className: 'rounded-lg no-shadow no-text-shadow no-border',
                },
                cancelButtonProps: {
                    className: 'rounded-lg no-shadow no-text-shadow no-border text-color-200',
                },
                onOk,
            }),
        [t]
    )
    return (
        <UseJoinAction join_status={true} {...props}>
            {(handleLeave) => (
                <div
                    onClick={() => {
                        showConfirmDialog(handleLeave)
                    }}
                    style={{width: 32, height: 32, borderRadius: '0.5rem', cursor: 'pointer'}}
                    className="flex flex-center bg-indigo-50 hover:bg-primary-100 text-indigo-500 hover:text-primary">
                    <IoExitOutline/>
                </div>
            )}
        </UseJoinAction>
    )
}

export const OrganizationJoinBlock = ({}) => {
    const t = useTranslate()
    const {isLg} = useContext(LayoutContext)
    const login = useContext(LoginContext)
    const {organization} = useContext(OrganizationContainerContext)
    const action_params = {
        id: getId(organization),
        type: getType(organization),
    }

    return (
        <div
            style={{
                boxShadow: '0 -2px 6px -2px rgba(0, 0, 0, 0.08), 0 8px 12px -4px rgba(0, 0, 0, 0.1)',
                ...(
                    isLg ? {
                        borderLeft: !organization?.follow_status ? '3px solid var(--color-primary)' : '1px solid var(--border-color-50)',
                        borderRight: !organization?.follow_status ? '3px solid var(--color-primary)' : '3px solid var(--color-secondary-500)',
                    } : {}
                )
            }}
            className={classNames(
                "p-4 background text-gray-700 shadow-lg rounded-xl flex flex-col items-center",
            )}>
            {organization?.join_status !== 1 && (
                <div className="mb-4 pb-2 flex flex-col">
                    <span className="text-center font-bold text-base tracking-wide leading-snug">
                        {t('would you like to join the Community')}
                    </span>
                    <span className="text-center text-sm tracking-wider leading-snug">
                        {t('let us serve together and spread the charism of the Community')}
                    </span>
                </div>
            )}

            {/* Action  */}
            <div className="mt-2 w-full flex items-center gap-3">
                {login && (
                    <TooltipApp title={login?.name} placement="topLeft" classNames={{root: "text-xs italic"}}>
                        <Avatar
                            src={login?.avatar}
                            icon={<BsPersonFill size={16} className="text-primary-600"/>}
                            className="flex flex-center bg-primary-50"
                        />
                    </TooltipApp>
                )}
                <div
                    className={classNames("flex-1 grid gap-3", organization?.join_status !== 1 ? 'grid-cols-2' : 'grid-cols-1')}>
                    <FollowButton item={organization}/>
                    {organization?.join_status !== 1 && (
                        <JoinButton {...action_params} item={organization}/>
                    )}
                </div>
                {organization?.join_status === 1 && (
                    <ActionMemberLeave {...action_params} />
                )}
            </div>

            <div className="mt-2 flex items-center gap-3">
                <span className="space-x-1 text-xs text-color-100 italic tracking-wide">
                    <strong>{organization?.total_followers}</strong>
                    <span className="text-color-200">
                        {t('followers')}
                    </span>
                </span>
                <span className="space-x-1 text-xs text-color-100 italic tracking-wide">
                    <strong>{organization?.total_members}</strong>
                    <span className="text-color-200">
                        {t('members')}
                    </span>
                </span>
            </div>

            {/* SHARE Wideget */}
            <OrganizationShareWidget
                header={
                    <span className="text-xs text-color-400 italic tracking-wide">
                        {`${t('share')}: `}
                    </span>
                }
                className="mt-3 gap-2"
            />
        </div>
    )
}